// Analytics-only (no reducer): drives the CDL v3 Pixall tag for the Recent Deals / deal-list surface.
// Lives in dash-store (the analytics hub) rather than activities-recent-deals so the middleware can key
// on it without creating a dash-store -> recent-deals dependency cycle (recent-deals already depends on
// dash-store).
export const CREATE_QUOTE_DEAL_LIST_CLICKED = 'CREATE_QUOTE_DEAL_LIST_CLICKED'; // dc-mv-325
